import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CashierWidget from './CashierWidget';
import { addCashierPayment } from '../../stateManagement/engine/actions/CheckoutActions';
import { createMandatoryFieldsObject } from '../../utils/CashierUtils';
import { deliveryTypeSelector } from '../../stateManagement/engine/selectors/deliveryTypeSelector';

function mapStateToProps(state, ownProps) {
  const singlePaymentMethod = state.checkout.singlePaymentMethod;
  const dispatchType = deliveryTypeSelector(state);
  const mandatoryFields = createMandatoryFieldsObject({
    contact: state.order.customer,
    dispatchType,
    address: state.order.address,
    paymentMethod: singlePaymentMethod,
  });

  const fields = singlePaymentMethod === 'offline' ? 'mandatoryFields' : 'mandatoryFieldsPrefilled';

  return {
    ...ownProps,
    [fields]: mandatoryFields,
    instance: state.session.instance,
    language: state.session.organization.locale.substr(0, 2),
    singlePaymentMethod: singlePaymentMethod,
    isCashierInitializing: state.checkout.isCashierInitializing,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addCashierPayment,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CashierWidget);
